import { defineMessages } from 'react-intl';

const messages = defineMessages({
  processing: {
    id: 'flags.processing',
    defaultMessage: 'This should only take a moment...',
  },
});

export default messages;
